<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn :to="'/content'" color="error" icon flat exact>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline primary--text">{{sectionData.name}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn :to="'/content/' + contentData.url + '/' + sectionData.url + '/create'" class="mx-2 my-0" color="success" depressed small>
      <v-icon class="mr-1" left small>add</v-icon>
      <span>Create</span>
    </v-btn>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-2 pb-2" xs12 md10>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else row wrap justify-center>
        <v-flex xs12>
          <v-tabs class="pa-0 ma-0" v-model="tab" color="transparent" slider-color="accent" centered>
            <v-tab ripple><b>Tasks</b></v-tab>
            <v-tab ripple><b>Edit</b></v-tab>
            <v-tab-item>
              <r-task-list></r-task-list>
            </v-tab-item>
            <v-tab-item>
              <r-edit-section></r-edit-section>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
import TaskList from './TaskList.vue'
import EditSection from './EditSection.vue'
export default {
  components: {
    rCrumbs: Crumbs,
    rTaskList: TaskList,
    rEditSection: EditSection
  },
  data: () => ({
    loading: false,
    tab: null,
    contentData: {},
    sectionData: {}
  }),
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      const sections = this.$store.getters.sectionByContent(this.contentData.key)
      for (let s of sections) {
        if (s.url === this.$route.params.sectionUrl) this.sectionData = s
      }
      this.loading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/ManageSection.vue